import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { CommonService } from '../common-service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MarkdownService } from '../markdown-service';
import { SanitizationService } from '../sanitization.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-saved-answer',
  templateUrl: './saved-answer.component.html',
  styleUrl: './saved-answer.component.scss'
})
export class SavedAnswerComponent implements OnInit,OnDestroy {
  saved_answers:any
  availableCollections:any
  selectedCollection:any
  username:any
  loader = true
  rows: number = 10;
  totalrecords = 0
  first: number = 0;
  pagenumber: number = 1;
  knowledge_gap:boolean= false;
  collectionId: any;
  openmodalapprove: boolean=false;
  dialogTitle='Answer_Approval Modal'
  CannedQuestionList: any[]=[];
  toggleStatus:boolean=false;
  searchloader: boolean=false;
  searchText: string = '';
  searchDebounce: any;
  searchControl = new FormControl('');
  task_response: any;
  selectedSearchOption: any= "All";
  availableFilter: any;
  qnmodalVisibility: boolean=false;
  original_qn: any;
  showChunkModal = false
  selectedChunks: any[] = [];
  chunkListenerAttached = false;
  highlightedChunkId: string | null = null;
  private shouldScrollToHighlighted = false;
 constructor(private api:CommonService,private sanitizer: DomSanitizer,
  private markdownService: MarkdownService,private sanitizeService:SanitizationService,private router: Router,
private elementRef: ElementRef,private renderer: Renderer2, private clipboard: Clipboard,
private readonly changeDetectorRef: ChangeDetectorRef){
  this.username = localStorage.getItem('username');
  window.addEventListener('storage', this.handleStorageChange.bind(this))
}

ngOnInit(): void {
  this.fetchCollections();

  this.availableFilter = [
    {
    searchFilter: 'All'
    },
    {
    searchFilter: 'AI-Generated'
    },
    {
    searchFilter: 'Cached'
    }
  ];

  this.searchControl.valueChanges
    .pipe(
      debounceTime(300) // wait 300ms after last keystroke
    )
    .subscribe((value: any) => {
      this.pagenumber = 1;
      this.first = 0;
      const trimmedValue = value?.trim() || '';
      if (trimmedValue.length > 1) { 
        this.searchText = trimmedValue; 
        this.searchSavedAnswers(trimmedValue);
      } else if (trimmedValue.length === 0) { 
        this.searchText='';
        this.selectedCollection = localStorage.getItem('selectedCollection') || (this.availableCollections?.[0]?.collectionName ?? '');
        this.savedAnswerBasedCollection();
      }
    });

  this.attachChunkClickListeners();  
}

attachChunkClickListeners(): void {
  if (this.chunkListenerAttached) return;
  this.chunkListenerAttached = true;

  const container = this.elementRef.nativeElement as HTMLElement;

  this.renderer.listen(container, 'click', (event: Event) => {
    const clicked = event.target as HTMLElement;

    const chunkSpan = clicked.closest('span[chunk_id]') as HTMLElement | null;
    if (!chunkSpan) return;

    const chunkId = chunkSpan.getAttribute('chunk_id');

    const answerBlock = chunkSpan.closest('.chunk-parent') as HTMLElement | null;
    if (!answerBlock) {
      console.warn('No .chunk-parent found for clicked chunk.');
      return;
    }

    const answerTypeAttr = answerBlock.getAttribute('data-answer-type');
    const questionIndex:any = answerBlock.getAttribute('data-question-index');
    
    const answerTypeDataset = (answerBlock.dataset && answerBlock.dataset['answerType']) || undefined;

    const answerType = answerTypeAttr ?? answerTypeDataset;
    if (!answerType) return;

    const parentAnswer =  this.saved_answers;
    if (!parentAnswer) {
      console.warn('No parentAnswer found on component for:', answerType);
      return;
    }

    let questionObj = parentAnswer.find((item:any, index:any) => {
      return parseInt(index) === parseInt(questionIndex);
    });
    this.selectedChunks = questionObj.chunksWithDocuments || [];
    this.highlightedChunkId = chunkId ? (Number(chunkId)).toString() : null;

    if (!this.showChunkModal) {
      this.openSidePanel();
    }

    // flag so ngAfterViewChecked knows to scroll
    this.shouldScrollToHighlighted = true;
  });
}

ngAfterViewChecked() {
  if (this.shouldScrollToHighlighted && this.showChunkModal) {
    this.shouldScrollToHighlighted = false;

    setTimeout(() => {
      const highlightedCard = this.elementRef.nativeElement
        .querySelector('.chunk-mini-card.highlighted') as HTMLElement | null;
      if (highlightedCard) {
        highlightedCard.scrollIntoView({ behavior: 'smooth'});
      }
    },500);
  }
}


openSidePanel(): void {
  console.log("function sidepanel");
  this.showChunkModal = true;
}

navigatechunkToDoc(chunk:any){
  const dataToPass = { documentId: chunk.document_id, collectionId: chunk.collection_id };
  this.api.setData(dataToPass);
  this.router.navigate(['collection', chunk.collection_name, 'document', chunk.document_id],
    { state: { highlight: chunk.chunk_text } }
  );
}

copyChunkExcerpt(text: string): void {
  this.clipboard.copy(text);
  this.changeDetectorRef.detectChanges();
}

  handleStorageChange(event: StorageEvent) {
    if (event.key === 'answerUpdated' && event.newValue === 'true') {
      this.savedAnswerBasedCollection();
      localStorage.removeItem('answerUpdated');
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('storage', this.handleStorageChange.bind(this));
 }
  private fetchCollections(): void {
    this.api.getMethod('get-collections/v2').subscribe((data: any) => {
      this.availableCollections = data;
      this.selectedCollection = localStorage.getItem('selectedCollection') ? localStorage.getItem('selectedCollection') : data[0].collectionName;
      setTimeout(()=>{
        this.savedAnswerBasedCollection();
        },1000)
    });
  }

  onPageChange(event: any) {
    this.loader = true;
    this.first = event.first;
    this.pagenumber = event.page + 1;  
    const searchText = this.searchControl.value?.trim();
  
    if (searchText) {
      this.searchSavedAnswers(searchText);
    } else {
      this.savedAnswerBasedCollection();
    }
  }
  
  onSearchButtonClick() {
    this.pagenumber = 1;
    const value = this.searchControl.value;
    this.searchText = value?.trim() || ''; 
    if (value && value.trim()) {
      this.searchSavedAnswers(value.trim());
    } else {
      this.savedAnswerBasedCollection();
    }
  }
   
  savedAnswerBasedCollection(){
    this.collectionId = this.availableCollections.find((x: any) => x.collectionName === this.selectedCollection)?.collection_id;
    this.saved_answers = ''
    let payload =
      {            
        "collection": this.selectedCollection,
        "page": this.pagenumber,
        "limit": 10,
        "Filter": this.selectedSearchOption
    }
    this.loader=true;
    this.api.postMethod('get-question-history?page='+this.pagenumber+'&collection='+this.selectedCollection,payload).subscribe({
      next:(data:any)=>{
        this.loader = false
        this.saved_answers = (data?.[this.username]?.[this.selectedCollection] || []).map((item: any) => {
          let isBotMenu = false;
          let botMenu: any[] = [];
          try {
            const parsed = JSON.parse(item.answer);
            if (Array.isArray(parsed) && parsed[0]?.buttons) {
              isBotMenu = true;
              botMenu = parsed;
              item.answer = parsed[0].text; // update answer to plain text
            }
          } catch (e) {
            // Not a bot menu - keep original answer
          }

          return {
            ...item,
            isBotMenu,
            botMenu
          };
        }
      );
  // this.task_response=this.saved_answers.canned_resp_type

        this.totalrecords = data?.total_count
      },
      error:(error:any)=>{
      }
   })
  }
  
  searchSavedAnswers(searchQuery: string) {
    this.loader = true;

    const payload = {
      collection: this.selectedCollection,
      searchQuery: searchQuery,
      page: this.pagenumber,
      limit: 10,
      Filter: this.selectedSearchOption
    };

    this.api.postMethod('get-question-history-search', payload)
      .subscribe({
        next: (data: any) => {
          this.loader = false;
         this.saved_answers = (data?.[this.username]?.[this.selectedCollection] || []).map((item: any) => {
          let isBotMenu = false;
          let botMenu: any[] = [];
          try {
            const parsed = JSON.parse(item.answer);
            if (Array.isArray(parsed) && parsed[0]?.buttons) {
              isBotMenu = true;
              botMenu = parsed;
              item.answer = parsed[0].text; // update answer to plain text
            }
          } catch (e) {
            // Not a bot menu - keep original answer
          }

          return {
            ...item,
            isBotMenu,
            botMenu
          };
        });

          this.totalrecords = data?.total_count || 0;
        },
        error: (error: any) => {
          this.loader = false;
          console.error('Error fetching search results:', error);
        }
      });
  }

  
  
  
  sanitizeMessage(message: string,searchText:any): SafeHtml {
    return this.sanitizeService.sanitizeMessage(message,searchText);
   }

   changeSearchOption(e: any){
    this.loader = true
    this.selectedSearchOption= e.value
    this.savedAnswerBasedCollection()
   }
    

  changeCollection(e:any){
   this.loader = true
   this.selectedCollection = e.value
   localStorage.setItem('selectedCollection',this.selectedCollection)
   this.savedAnswerBasedCollection()
  }
  getAbsoluteUrl(questionId: number): string {
    const tree = this.router.createUrlTree(['/faq'], { queryParams: { questionid: questionId } });
    return `${window.location.origin}${this.router.serializeUrl(tree)}`;
  }
  viewQuest(answer:any){
    let questionId=answer.canned_question_id;
    localStorage.setItem('OC_ID',answer.id);
    const url = this.getAbsoluteUrl(questionId);
    window.open(url, '_blank');
  }
  knowledgegap(questionId:number){
  let answer = this.saved_answers.find((ans:any) => ans.canned_question_id === questionId);

  if (answer) {
    const body = {
      id: questionId,
      value: !answer.knowledge_gap
    };

    this.api.putMethod("canned/updateKnowledgeGap", body).subscribe({
      next: (data: any) => {
        if (data.data.knowledge_gap === true) {
          answer.knowledge_gap = true;
        } else {
          answer.knowledge_gap = false;
        }
      },
      error: (error: any) => {
        console.error('Error updating knowledge gap:', error);
      }
    });
  }
}
navigateToDoc(doc:any){
  const dataToPass = { documentId: doc.document_id, collectionId: this.collectionId };
  this.api.setData(dataToPass);
  this.router.navigate(['collection', this.selectedCollection, 'document', doc.document_name]);
}
openAnsapprovemodal(data:any){
  this.openmodalapprove=true;
  this.CannedQuestionList=[];

  this.fetchSimilarquestList(data.question)

}

sanitizedMessage(message: string): SafeHtml {
  return this.sanitizeService.sanitizeMessage(message);
  }
onDialogHideaddcollection(){
  this.openmodalapprove=false;
}
fetchSimilarquestList(question:any){
  this.searchloader=true;
  let  body={"question": question,
      "collection": this.selectedCollection,
    "num_of_similar_questions":10,
  "matching_score_threshold":0.95
  }
  this.api.postMethod(`canned-search`,body).subscribe({
    next:(data:any)=>{this.CannedQuestionList=data.filter((item:any) => item.canned_question_id > 0);
      this.searchloader=false;
    },
    error:(err:any)=>{
      console.log("error in fetching canned answer",err);
      this.CannedQuestionList=[];
      this.searchloader=false;
    }
  })
}
onToggleChange(doc: any) {
  const updatedStatus = doc.canned_answer_approved == 1 ? 0 : 1; // Toggle between 1 and 0
  const payload = {  };

  this.api.patchMethod(`toggle-approval/${doc.canned_question_id}`, payload).subscribe({
    next: (response) => {
      doc.canned_answer_approved = response.data.answer_approved;
      const savedanswerIndex = this.saved_answers.findIndex(
        (ans: any) => ans.canned_question_id === doc.canned_question_id
      );
      if (savedanswerIndex !== -1) {
        this.saved_answers[savedanswerIndex].answer_approved = response.data.answer_approved;
        console.log("Updated saved answer:", this.saved_answers[savedanswerIndex]);
      } else {
        console.log("No matching saved answer found for ID:", doc.canned_question_id);
      }
    },
    error: (error) => {
      console.error('Error updating toggle:', error);
    }
  });
} 
}
